
        <ng-content></ng-content>
    


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/grid/row/row.component.ts.RowComponent.html